<template>
  <div>
  <!-- MAIN -->
  <div class="breadcrumbs ace-save-state" id="breadcrumbs">
    <ul class="breadcrumb">
      <li>
        <i class="ace-icon fa fa-home home-icon"></i>
        <a href="#/">メインメニュー</a>
      </li>
      <router-link tag="li" :to="{name: 'useredit', query: { id: userId }}">
        <a>ユーザー編集</a>
      </router-link>
      <li class="active">個人コードを追加</li>
    </ul><!-- /.breadcrumb -->
  </div>
  <div class="page-header">
    <div class="checkbox">
      <label class="checkbox-box">
        <input name="scorp" type="checkbox" class="ace pCodeId" checked="checked" @click="addRomoveScorp('pCodeId', 'pCodeId')">
        <span class="lbl">個人コード</span>
      </label>
      <label class="checkbox-box">
        <input name="scorp" type="checkbox" class="ace userId" checked="checked" @click="addRomoveScorp('userId', 'userId')">
        <span class="lbl">ユーザーID</span>
      </label>
      <span class="input-icon search-box">
        <input type="text" placeholder="選択項目にチェックして検索" class="nav-search-input" id="nav-search-input" autocomplete="off">
        <i class="ace-icon fa fa-search nav-search-icon"></i>
      </span>
      <button class="btn-cusstom green-btn" type="button" @click="search()">検索</button>
      <button class="btn-cusstom green-btn" type="button" href="#process" data-toggle="modal" @click="resetStatus()">チェックした個人コードを追加する</button>
      <button class="btn-cusstom black-btn pull-right" type="button" @click="cancel()">ユーザー編集画面に戻る</button>
    </div>
  </div><!-- /.page-header -->
  <!-- END MAIN -->
  <div class="page-content">
    <div class="alert alert-danger" v-if="errorMessageLogs!==''">
      {{ errorMessageLogs }}
    </div>
    <div id="loading" v-if="loading"><div class="loadingMsg"></div></div>
    <div class="scroll-data-content">
        <div class="pull-right">
          <a class="option_button" data-toggle="collapse" data-parent="#accordion" href="#collapseOne" aria-expanded="false">表示オプション&nbsp;
            <i class="bigger-110 ace-icon fa fa-angle-down" data-icon-hide="ace-icon fa fa-angle-up" data-icon-show="ace-icon fa fa-angle-down"></i>
          </a>
        </div>
        <div class="clearfix" style="clear:both">
          <div id="accordion">
            <div class="panel-collapse collapse" id="collapseOne" aria-expanded="false" style="height: 0px;">
              <div class="panel-body">
                <div class="control-group">
                  <label class="control-label bolder blue display_block">表示項目</label>
                  <div class="checkbox table_items">
                    <label>
                      <input name="pcode_id" type="checkbox" class="ace" disabled checked="checked">
                      <span class="lbl"> 個人コード</span>
                    </label>
                  </div>
                  <div class="checkbox table_items">
                    <label>
                      <input name="pcode_userid" type="checkbox" class="ace" @click="ShowHideColumn" checked="checked" v-model="checkedColumnNames" value="userId">
                      <span class="lbl">ユーザーID</span>
                    </label>
                  </div>
                  <div class="checkbox table_items">
                    <label>
                      <input name="pcode_type" type="checkbox" class="ace" @click="ShowHideColumn" checked="checked" v-model="checkedColumnNames" value="type">
                      <span class="lbl">コード種別</span>
                    </label>
                  </div>
                  <div class="checkbox table_items">
                    <label>
                      <input name="pcode_status" type="checkbox" class="ace" @click="ShowHideColumn" checked="checked" v-model="checkedColumnNames" value="status">
                      <span class="lbl">ステータス</span>
                    </label>
                  </div>
                  <div class="checkbox table_items">
                    <label>
                      <input name="pcode_date" type="checkbox" class="ace" @click="ShowHideColumn" checked="checked" v-model="checkedColumnNames" value="registered">
                      <span class="lbl">登録日</span>
                    </label>
                  </div>
                  <div class="checkbox table_items">
                    <label>
                      <input name="pcode_updated" type="checkbox" class="ace" @click="ShowHideColumn" checked="checked" v-model="checkedColumnNames" value="updated">
                      <span class="lbl">更新日</span>
                    </label>
                  </div>
                </div>
                <div class="control-group">
                  <label class="control-label bolder blue display_block">ページことに表示する項目</label>
                  <select id="pageSizeOptions" class="first-child last-child" @change="handleSizeChange" v-model="selected">
                    <option v-for="pageSize in pageSizeOptions" v-bind:value="pageSize" v-bind:key="pageSize">
                    {{ pageSize }} 件
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
        <table id="simple-table" class="table  table-bordered table-hover dataTable" v-if="list!=null">
          <thead>
            <tr>
              <th class="center">
                <label class="pos-rel">
                  <input type="checkbox" class="ace" v-model="selectAll">
                  <span class="lbl"></span>
                </label>
              </th>
              <th id="pcode_id" class="pcode_id sorting" @click="sort('pCodeId', 'pcode_id')">個人コード</th>
              <th id="pcode_userid" class="pcode_userid sorting" @click="sort('userId', 'pcode_userid')" v-bind:class="{'none': checkColumnShowHide('userId')}">ユーザーID</th>
              <th id="pcode_type" class="pcode_type sorting center" @click="sort('type', 'pcode_type')" v-bind:class="{'none': checkColumnShowHide('type')}">コード種別</th>
              <th id="pcode_status" class="center pcode_status sorting" @click="sort('isValid', 'pcode_status')" v-bind:class="{'none': checkColumnShowHide('status')}">ステータス</th>
              <th id="pcode_date" class="center pcode_date sorting" @click="sort('registered', 'pcode_date')" v-bind:class="{'none': checkColumnShowHide('registered')}">登録日</th>
              <th id="pcode_updated" class="center pcode_updated sorting" @click="sort('updated', 'pcode_updated')" v-bind:class="{'none': checkColumnShowHide('updated')}">更新日</th>
            </tr>
          </thead>
          <tbody v-for="(item, index) in list" :key="index">
            <tr class="existItem" v-bind:class="{'selected': rowSelectedExistPcode(item.pCodeId)}" :id="item.pCodeId" v-if="rowSelectedExistPcode(item.pCodeId)">
              <td class="center">
                <label class="pos-rel">
                  <input type="checkbox" class="ace" disabled :value="item.pCodeId" v-model="existPcodeId">
                  <span class="lbl"></span>
                </label>
              </td>
              <td class="pcode_id" @click="showdetail">{{item.pCodeId}}</td>
              <td class="pcode_userid" @click="showdetail" v-bind:class="{'none': checkColumnShowHide('userId')}">{{item.userId}}</td>
              <td class="center pcode_type" @click="showdetail" v-bind:class="{'none': checkColumnShowHide('type')}">{{item.type}}</td>
              <td class="center pcode_status" @click="showdetail" v-bind:class="{'none': checkColumnShowHide('status')}">
                <span v-if="item.isValid">有効</span>
                <span v-else >無効</span>
              </td>
              <td class="center pcode_date" @click="showdetail" v-bind:class="{'none': checkColumnShowHide('registered')}">{{ converDate(item.registered) }}</td>
              <td class="center pcode_updated" @click="showdetail" v-bind:class="{'none': checkColumnShowHide('updated')}">{{ converDate(item.updated) }}</td>
            </tr>
            <tr v-bind:class="{'selected': rowSelected(item.pCodeId)}" :id="item.pCodeId" v-else>
              <td class="center">
                <label class="pos-rel">
                  <input type="checkbox" class="ace" :value="item.pCodeId" v-model="selectedPcodeId">
                  <span class="lbl"></span>
                </label>
              </td>
              <td class="pcode_id" @click="showdetail">{{item.pCodeId}}</td>
              <td class="pcode_userid" @click="showdetail" v-bind:class="{'none': checkColumnShowHide('userId')}">{{item.userId}}</td>
              <td class="center pcode_type" @click="showdetail" v-bind:class="{'none': checkColumnShowHide('type')}">{{item.type}}</td>
              <td class="center pcode_status" @click="showdetail" v-bind:class="{'none': checkColumnShowHide('status')}">
                <span v-if="item.isValid">有効</span>
                <span v-else >無効</span>
              </td>
              <td class="center pcode_date" @click="showdetail" v-bind:class="{'none': checkColumnShowHide('registered')}">{{ converDate(item.registered) }}</td>
              <td class="center pcode_updated" @click="showdetail" v-bind:class="{'none': checkColumnShowHide('updated')}">{{ converDate(item.updated) }}</td>
            </tr>
          </tbody>
        </table>
        <table id="simple-table" class="table  table-bordered table-hover dataTable" v-else>
          <thead>
            <tr>
              <th class="center">
                <label class="pos-rel">
                  <input type="checkbox" class="ace">
                  <span class="lbl"></span>
                </label>
              </th>
              <th>個人コード</th>
              <th v-bind:class="{'none': checkColumnShowHide('userId')}">ユーザーID</th>
              <th v-bind:class="{'none': checkColumnShowHide('type')}">コード種別</th>
              <th v-bind:class="{'none': checkColumnShowHide('status')}">ステータス</th>
              <th v-bind:class="{'none': checkColumnShowHide('registered')}">登録日</th>
              <th v-bind:class="{'none': checkColumnShowHide('updated')}">更新日</th>
            </tr>
          </thead>
          <tbody>
            <tr><td colspan="7">{{ message }}</td></tr>
          </tbody>
        </table>
    </div><!-- /.row -->
    <div class="row pd-t-10">
      <div class="col-xs-12">
        <div class="dataTables_paginate paging_simple_numbers" v-if="pages>0">
          <paginate
            :page-count="pages"
            :page-range="3"
            :margin-pages="2"
            :click-handler="handleCurrentChange"
            :prev-text="'<<'"
            :next-text="'>>'"
            :container-class="'pagination'"
            :page-class="'page-item'">
          </paginate>
        </div>
      </div>
    </div>
  </div>
  <!-- プロフィールModal -->
  <div id="process" class="modal fade" tabindex="-1">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
          <h3 class="smaller lighter frofile-title no-margin">チェックした個人コードを追加する</h3>
        </div>
        <div class="modal-body">
          <span class="progress-question">チェックした個人コードを追加する、よろしいですか？</span>
          <div class="progress" v-bind:class="{'progress-striped':!success , active:!success, hide: !success}">
            <div class="progress-bar" :style="progressWidth">
            <span>{{ Math.round(progress) }}%</span>
            </div>
          </div>
          <span class="success-label" v-if="successPcode>0">{{countPcode}}件中{{successPcode}}件を追加しました。</span>
          <div v-if="errorMessage.length>0">
          <span class="error-box-title">追加失敗</span>
          <div class="error-box">
            <template v-for="item in errorMessage">
              <p v-html="item" :key="item"></p>
            </template>
          </div>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-sm btn-success pull-right" style="width:100px" data-dismiss="modal" v-if="success">OK</button>
          <button class="btn btn-sm btn-danger pull-right" style="width:100px" v-if="!success" :disabled="isDisabled" @click="addPcodeToUser()">実行</button>
        </div>
      </div><!-- /.modal-content -->
    </div><!-- /.modal-dialog -->
  </div>
  </div>
</template>

<script>
import * as Config from '../../config'
import moment from 'moment'

export default {
  data () {
    return {
      list: null,
      errorMessageLogs: '',
      message: 'データー取得中',
      checkedColumnNames: [
        'userId',
        'type',
        'status',
        'registered',
        'updated'
      ],
      scorp: ['pCodeId', 'userId'],
      userId: '',
      pages: 0,
      error: null,
      pCodeConfigTypes: null,
      pageSizeOptions: [25, 50, 100, 1000],
      listQuery: {
        currPage: 1,
        pageSize: 100
      },
      progress: 0,
      selected: 100,
      selectedPcodeId: [],
      existPcodeId: [],
      success: false,
      loading: false,
      isDisabled: false,
      errorMessage: [],
      successPcode: 0,
      errorName: '',
      countPcode: 0,
      exeCount: 0,
      percent: 0
    }
  },
  // countPcodeとはチェックしたアイテム数。
  // exeCountとはAPI実行回数、デフォルトの値は０です。
  // 一回APIを実行が終わるとexeCountに１をプラスする。
  // 全部APIを実行が終わるとexeCountの値は０にリセットする。
  // exeCount<countPcodeの時は次のAPI実行。
  // exeCount===countPcodeの時(全部APIを実行が終わったの時)は変数の値リセットする。
  watch: {
    'checkedColumnNames': 'updateChecked',
    exeCount: function (newVal, oldVal) {
      var vm = this
      if (newVal > 0 && newVal < vm.countPcode) {
        vm.addPcode(this.selectedPcodeId[newVal], vm.percent, newVal)
      } else if (newVal > 0 && newVal === vm.countPcode) {
        this.exeCount = 0
        this.success = true
        this.selectedPcodeId = []
      }
    }
  },
  created () {
    if (typeof localStorage.pageSizeUserPcode === 'undefined') {
      localStorage.setItem('pageSizeUserPcode', 100)
      this.selected = localStorage.pageSizeUserPcode
    } else {
      this.selected = localStorage.pageSizeUserPcode
    }
    if (typeof localStorage.userPcodeSortKey === 'undefined') {
      localStorage.setItem('userPcodeSortKey', 'pCodeId')
    }
    if (typeof localStorage.userPcodeSortName === 'undefined') {
      localStorage.setItem('userPcodeSortName', 'desc')
    }
    if (typeof localStorage.checkedUserPcode === 'undefined') {
      localStorage.setItem('checkedUserPcode', this.checkedColumnNames)
    } else {
      var tempData = []
      this.checkedColumnNames.forEach(function (item) {
        if (localStorage.checkedUserPcode.indexOf(item) !== -1) {
          tempData.push(item)
        }
      })
      this.checkedColumnNames = tempData
    }
    this.getList()
    this.fetchData()
  },
  mounted () {
    var vm = this
    $('#nav-search-input').keyup(function (e) {
      if (e.keyCode === 13) {
        vm.search()
      }
    })
  },
  computed: {
    progressWidth: function () {
      return 'width:' + this.progress + '%'
    },
    selectAll: {
      get: function () {
        // true：帰ってきたら一番上の全件チェックボックスはチェックをつける。
        // false：帰ってきたら一番上の全件チェックボックスはチェックをつけない。
        // selectedPcodeIdとは、ユーザーがチェックボックスをチェックした数。
        // selectedPcodeIdが0より大きい時はチェックをつけない（false）
        // selectedPcodeIdが１以上の時は、次のロジックで判定する。
        // existItemとは、カレントページで元々チェックされているチェックボックスの数。
        // list.lengthとは「ページオプション」の「ページことに表示する項目」の数値。
        // selectedPcodeId + existItemの結果が、list.length以上であれば、true、list.length未満であれば、false。
        if (this.selectedPcodeId.length > 0) {
          var existItem = $('tr.existItem').length
          return this.list ? (this.selectedPcodeId.length + existItem) >= this.list.length : false
        } else {
          return false
        }
      },
      set: function (value) {
        var vm = this
        var selectedPcodeId = []
        if (value) {
          this.list.forEach(function (item) {
            if (!vm.rowSelectedExistPcode(item.pCodeId)) {
              selectedPcodeId.push(item.pCodeId)
            }
          })
        }
        this.selectedPcodeId = selectedPcodeId
      }
    }
  },
  methods: {
    updateChecked () {
      localStorage.setItem('checkedUserPcode', this.checkedColumnNames)
    },
    checkColumnShowHide (columnName) {
      if (localStorage.checkedUserPcode.indexOf(columnName) !== -1) {
        return false
      } else {
        return true
      }
    },
    cancel () {
      this.$router.push({name: 'useredit', query: { id: this.userId }})
    },
    fetchData () {
      var data = this.$route.query
      this.userId = data.id
      this.getInforUserPcode(this.userId)
    },
    getInforUserPcode (userId) {
      this.$http.get(Config.PCODE_LIST_API + '?userId=' + encodeURIComponent(userId))
        .then(response => {
          var dataPcodes = response.body.pCodes
          var selectedPcodeId = []
          if (dataPcodes.length > 0) {
            for (var i = 0; i < dataPcodes.length; i++) {
              selectedPcodeId.push(dataPcodes[i].pCodeId)
            }
          }
          this.existPcodeId = selectedPcodeId
        })
        .catch((error) => {
          console.log(error)
        })
    },
    handleEdit (id) {
      this.$router.push({name: 'phoneedit', query: { id: id }})
    },
    converDate (t) {
      return moment(new Date(t * 1000)).format('YYYY/MM/DD HH:mm')
    },
    converTimestamp (t) {
      return parseInt(new Date(t) / 1000)
    },
    // スマートフォン詳細を開く
    showdetail: function (e) {
      e.preventDefault()
      $(e.target).closest('tr').next().toggleClass('open')
    },
    // チェックした個人コードを追加する前にリセット
    resetStatus () {
      $('.progress').addClass('hide')
      $('.progress-question').html('チェックした個人コードを追加する、よろしいですか？')
      this.progress = 0
      this.success = false
      this.isDisabled = false
      this.errorMessage = []
      this.successPcode = 0
      this.countPcode = 0
    },
    rowSelectedExistPcode (pcodeId) {
      if (jQuery.inArray(pcodeId, this.existPcodeId) !== -1) {
        return true
      } else {
        return false
      }
    },
    // 行にチェックする
    rowSelected (pcodeId) {
      if (jQuery.inArray(pcodeId, this.selectedPcodeId) !== -1) {
        return true
      } else {
        return false
      }
    },
    // チェックした個人コードを追加する
    addPcode (pCodeId, percent, i) {
      var vm = this
      this.$http.put(Config.PCODE_LIST_API + '/' + encodeURIComponent(pCodeId), {isValid: true, userId: this.userId})
        .then(response => {
          vm.progress += percent
          vm.existPcodeId.push(pCodeId)
          vm.successPcode += 1
          vm.exeCount++
        })
        .catch((error) => {
          console.log(error)
          this.progress += percent
          switch (error.status) {
            case 401:
              if (error.body.message === 'The incoming token has expired') {
                this.errorName = ''
              } else {
                this.errorName = 'アクセス情報が不正です。ログインし直してからやり直してください。'
              }
              break
            case 400:
              this.errorName = '入力したパラメーターが誤っています。入力内容をご確認ください。'
              break
            case 403:
              this.errorName = 'アクセス情報が不正です。ログインし直してからやり直してください。'
              break
            case 404:
              this.errorName = '該当するデーターがありません。'
              break
            case 409:
              this.errorName = '入力された個人コードは既に関連付けされています。'
              break
            case 420:
              this.errorName = '個人コード登録数が上限に達しています。'
              break
            case 500:
              this.errorName = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
            case 503:
              this.errorName = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
            default:
              this.errorName = 'アクセス情報が不正です。ログインし直してからやり直してください。'
              break
          }
          var rowstatus = pCodeId + '>><span>' + this.errorName + '</span>'
          this.$set(this.errorMessage, i, rowstatus)
          vm.exeCount++
        })
    },
    addPcodeToUser () {
      var vm = this
      vm.isDisabled = true
      if (this.selectedPcodeId.length > 0) {
        this.countPcode = this.selectedPcodeId.length
        $('.progress').removeClass('hide')
        $('.progress-question').html('処理状況')
        vm.percent = (100 / this.selectedPcodeId.length)
        vm.addPcode(this.selectedPcodeId[0], vm.percent, 0)
      } else {
        alert('少なくても個人コードを１つ選んでください。')
      }
    },
    // 検索項目チェンジ
    addRomoveScorp (classname, scorpname) {
      if ($('.' + classname).prop('checked')) {
        this.scorp.push(scorpname)
      } else {
        this.scorp.splice($.inArray(scorpname, this.scorp), 1)
      }
    },
    // 検索
    search () {
      this.loading = true
      this.errorMessageLogs = ''
      if (this.scorp.length > 0) {
        var keyword = $('.nav-search-input').val()
        keyword = keyword.replace(/\s/g, ',')
        keyword = encodeURIComponent(keyword)
        this.$http.get(Config.PCODE_LIST_API + '?limit=' + localStorage.pageSizeUserPcode + '&page=' + this.listQuery.currPage + '&keyword=' + keyword + '&scorp=' + this.scorp + '&sortKey=' + localStorage.userPcodeSortName + ':' + localStorage.userPcodeSortKey + '&isValid=true')
          .then(response => {
            this.loading = false
            this.pages = Math.ceil((response.body.maxRecords) / localStorage.pageSizeUserPcode)
            if (response.body.maxRecords > 0) {
              this.list = response.body.pCodes
            } else {
              this.list = null
            }
            for (var i = 0; i < this.list.length; i++) {
              this.getTypeInfo(this.list[i].type, i)
            }
            console.log(response)
          })
          .catch((error) => {
            console.log(error)
            this.list = null
            this.loading = false
            this.message = '該当するデーターがありません。'
          })
      } else {
        alert('少なくても検索項目を１つ選んでください。')
        this.loading = false
      }
    },
    // ソート
    sort (sortkey, elementname) {
      this.loading = true
      if ($('#' + elementname).hasClass('sorting_asc')) {
        $('#simple-table>thead>tr>th').removeClass('sorting_asc')
        $('#simple-table>thead>tr>th').removeClass('sorting_desc')
        $('#' + elementname).removeClass('sorting_asc')
        $('#' + elementname).addClass('sorting_desc')
        localStorage.setItem('userPcodeSortName', 'desc')
        localStorage.setItem('userPcodeSortKey', sortkey)
      } else {
        $('#simple-table>thead>tr>th').removeClass('sorting_asc')
        $('#simple-table>thead>tr>th').removeClass('sorting_desc')
        $('#' + elementname).removeClass('sorting_desc')
        $('#' + elementname).addClass('sorting_asc')
        localStorage.setItem('userPcodeSortName', 'asc')
        localStorage.setItem('userPcodeSortKey', sortkey)
      }
      this.getList()
    },
    // １ページに表示する項目数
    handleSizeChange () {
      this.listQuery.pageSize = $('#pageSizeOptions').val()
      localStorage.setItem('pageSizeUserPcode', this.listQuery.pageSize)
      this.listQuery.currPage = 1
      this.getList()
    },
    // ページネーションチェンジ
    handleCurrentChange (val) {
      this.selectedPcodeId = []
      this.listQuery.currPage = val
      this.getList()
    },
    // コラム表示する
    ShowHideColumn: function (e) {
      var $tbl = $('#simple-table')
      var colToHide = $tbl.find('.' + $(e.target).attr('name'))
      $(colToHide).toggle()
    },
    // NFC読み取り設定種別取得
    getTypeInfo (type, j) {
      var vm = this
      if (type === 0) {
        vm.list[j].type = 'NFCカード'
      } else {
        vm.list[j].type = 'テンキー入力'
      }
    },
    // スマートフォン一覧
    getList () {
      this.loading = true
      if (this.list !== null) {
        var keyword = $('.nav-search-input').val()
        keyword = keyword.replace(/\s/g, ',')
        keyword = encodeURIComponent(keyword)
      } else {
        keyword = ''
      }
      this.$http.get(Config.PCODE_LIST_API + '?limit=' + localStorage.pageSizeUserPcode + '&page=' + this.listQuery.currPage + '&keyword=' + keyword + '&scorp=' + this.scorp + '&sortKey=' + localStorage.userPcodeSortName + ':' + localStorage.userPcodeSortKey + '&isValid=true')
        .then(response => {
          this.loading = false
          this.pages = Math.ceil((response.body.maxRecords) / localStorage.pageSizeUserPcode)
          if (response.body.maxRecords > 0) {
            this.list = response.body.pCodes
          } else {
            this.list = null
          }
          for (var i = 0; i < this.list.length; i++) {
            this.getTypeInfo(this.list[i].type, i)
          }
          console.log(response)
        })
        .catch(error => {
          this.list = null
          this.loading = false
          this.message = '該当するデーターがありません。'
          switch (error.status) {
            case 401:
              if (error.body.message === 'The incoming token has expired') {
                this.errorMessageLogs = ''
              } else {
                this.errorMessageLogs = 'アクセス情報が不正です。ログインし直してからやり直してください。'
              }
              break
            case 400:
              this.errorMessageLogs = '入力したパラメーターが誤っています。入力内容をご確認ください。'
              break
            case 403:
              this.errorMessageLogs = '個人コードの取得権限がありません。'
              break
            case 404:
              this.errorMessageLogs = '該当するデーターがありません。'
              break
            case 500:
              this.errorMessageLogs = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
            case 503:
              this.errorMessageLogs = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
            default:
              this.errorMessageLogs = 'アクセス情報が不正です。ログインし直してからやり直してください。'
              break
          }
        })
    }
  }
}
</script>

<style>
.checkbox label, .radio label {
  padding-left: 10px!important
}
.checkbox-box{
  margin-right: 15px
}
.edit-bottom,.delete-bottom{
  width: 100%;
  margin-bottom: 15px
}
.fa-6{
  font-size: 3em;
}
.fa-3{
  font-size: 2em;
}
.table>tbody>tr>td{
  vertical-align: middle;
  padding: 5px;
  font-size: 16px;
}
.dataTables_paginate .pagination {
  margin: 0;
}
.table-bordered>tbody>tr>td{
  border-right:3px solid #fff;
}
.label-sm {
  padding: 10px;
  font-size: 16px;
  line-height: 1;
  height: auto;
}
.table-detail .profile-info-name{
  width: 195px
}
.device{
  margin-top: 50px;
  border-top: 2px solid #ccc
}
.table-detail .accordion-style1.panel-group .panel-heading .accordion-toggle.collapsed{
  font-size: 18px
}
.table-detail .accordion-style1.panel-group .panel-heading .accordion-toggle{
  font-size: 18px
}
.add-buttom{
  margin-bottom: 10px
}
.modal-content .form-horizontal .control-label{
  text-align: left;
}
.chosen-container-single .chosen-single{
  border-radius: 0px;
  height: 35px;
  font-size: 16px;
  line-height: 35px!important;
}
.chosen-container-single{
  width: 100%!important
}
.chosen-container{
  margin-bottom: 10px
}
.dataTable>thead>tr>th[class*=sorting_]{
  color: #707070
}
.modal-content .form-horizontal .control-label{
  text-align: left;
}
.chosen-container-single .chosen-single{
  border-radius: 0px;
  height: 35px;
  font-size: 16px;
  line-height: 35px!important;
}
.chosen-container-single{
  width: 100%!important
}
.chosen-container{
  margin-bottom: 10px
}
.dataTable>thead>tr>th[class*=sorting_]{
  color: #707070
}
</style>



// WEBPACK FOOTER //
// src/views/user/UserPcodeAdd.vue